/* Assets/copy-code.js */
// Robust copy-to-clipboard with fallbacks + works with Shopify section reloads.

(function () {
  const SELECTOR_BTN = '[data-copy-btn]';
  const SELECTOR_WRAP = '[data-discount-wrapper]';
  const SELECTOR_CODE = '[data-discount-code]';
  const SELECTOR_FEEDBACK = '[data-copy-feedback]';

  function copyText(text) {
    // Prefer modern API when secure (HTTPS)
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    // Fallback for older browsers / preview contexts
    const temp = document.createElement('textarea');
    temp.value = text;
    temp.setAttribute('readonly', '');
    temp.style.position = 'fixed';
    temp.style.top = '-9999px';
    document.body.appendChild(temp);
    temp.select();
    try { document.execCommand('copy'); } catch (e) { /* ignore */ }
    document.body.removeChild(temp);
    return Promise.resolve();
  }

  function findCodeText(wrapper, btn) {
    // Priority 1: data-code on button
    const fromData = btn && btn.getAttribute('data-code');
    if (fromData && fromData.trim()) return fromData.trim();

    // Priority 2: read from sibling <code> element
    const codeEl = wrapper && wrapper.querySelector(SELECTOR_CODE);
    if (codeEl && codeEl.textContent.trim()) return codeEl.textContent.trim();

    // Priority 3: last resort – text node inside wrapper
    return (wrapper && wrapper.textContent || '').trim();
  }

  function showFeedback(wrapper, btn) {
    const fb = wrapper.querySelector(SELECTOR_FEEDBACK);
    if (btn) {
      const original = btn.textContent;
      btn.textContent = 'Copied!';
      setTimeout(() => (btn.textContent = 'Copy code'), 1500);
    }
    if (fb) {
      fb.removeAttribute('hidden');
      fb.setAttribute('aria-live', 'polite');
      setTimeout(() => fb.setAttribute('hidden', ''), 1500);
    }
  }

  // Event delegation: safe across re-renders
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTOR_BTN);
    if (!btn) return;
    const wrapper = btn.closest(SELECTOR_WRAP);
    if (!wrapper) return;

    const text = findCodeText(wrapper, btn);
    if (!text) return;

    copyText(text).then(() => showFeedback(wrapper, btn));
  });

  // Re-bind on Theme Editor section loads (Shopify)
  ['shopify:section:load', 'shopify:section:select', 'shopify:section:unload'].forEach(evt =>
    document.addEventListener(evt, () => { /* delegation already attached */ })
  );
})();
